import { useState } from "react";
import LegalLayout from "../components/LegalLayout";
import { api } from "../lib/api";
import { toast } from "sonner";
import { apiErrorMessage } from "../lib/errors";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.message.length < 5) {
      toast.error("Message is too short");
      return;
    }
    setLoading(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Message sent");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Could not send"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <LegalLayout
      title="Contact us"
      overline="SUPPORT"
      path="/contact"
      description="Get in touch with the Martingale Playbook support team."
    >
      <p className="text-lg">
        Got a question about your subscription, a bug report, or feedback on the AI
        picks? Drop us a note — we read every message.
      </p>

      {sent ? (
        <div
          data-testid="contact-sent"
          className="border border-[#00D4FF]/40 bg-[#00D4FF]/5 p-6 mt-6"
        >
          <div className="overline neon-text mb-2">MESSAGE RECEIVED</div>
          <div className="text-sm text-zinc-300">
            Thanks {form.name}. We'll reply to {form.email} within 48 hours.
          </div>
        </div>
      ) : (
        <form
          onSubmit={submit}
          className="mt-8 space-y-5 border border-zinc-800 p-8 bg-zinc-950/40"
        >
          <div>
            <label className="overline block mb-2">NAME</label>
            <input
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              data-testid="contact-name"
              className="w-full bg-transparent border border-zinc-800 px-3 py-3 mono text-sm focus:outline-none focus:border-[#00D4FF]"
            />
          </div>
          <div>
            <label className="overline block mb-2">EMAIL</label>
            <input
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="contact-email"
              className="w-full bg-transparent border border-zinc-800 px-3 py-3 mono text-sm focus:outline-none focus:border-[#00D4FF]"
            />
          </div>
          <div>
            <label className="overline block mb-2">MESSAGE</label>
            <textarea
              required
              rows={7}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              data-testid="contact-message"
              className="w-full bg-transparent border border-zinc-800 px-3 py-3 mono text-sm focus:outline-none focus:border-[#00D4FF] resize-vertical"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="contact-submit"
            className="w-full py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs disabled:opacity-50 hover:brightness-110"
          >
            {loading ? "Sending..." : "Send message"}
          </button>
        </form>
      )}
    </LegalLayout>
  );
}